// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"08abbbf1","455":"c8517e07","977":"3d3ce099"}[chunkId] + ".chunk.js";
};